import { orderHelper } from "@shop/frontend/web/js/helpers/OrderHelper";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { helpers } from "@shop/frontend/web/js/helpers";

export class EventOrderView {
	constructor() {
		this.$eventSum = $("#js-event-sum");
		this.$ticketsItems = $("#js-tickets-items");

		this.$placesBuy = $("#js-places-buy");
		this.$tickets = $(".js-tickets");

		this.ticketTemplate = $("#js-ticket-template")[0];
	}

	/**
	 * Рендерит заказ мероприятия
	 * @param order {Object} - Модель заказа
	 */
	render(order) {
		this.$eventSum.text(order.amount);

		this.updateBuyButtonText(order.amount);

		this.$ticketsItems.html("");
		$.each(order.carts, (i, cart) => {
			let sector = translator.t("event", cart.sector) || cart.view_id;
			if (sector) {
				sector =
					!cart.is_pack && !cart.hide
						? translator.t("main", "Sector") + " " + sector
						: translator.t("event", cart.sector);
			}

			cart.name = `${translator.t("main", "Row")} ${cart.row} ${translator.t(
				"main",
				"place"
			)} ${cart.col}`;

			this.$ticketsItems.append(
				orderHelper.insertDataToTicket(
					$(document.importNode(this.ticketTemplate.content, true)),
					{
						...cart,
						sector,
						order_id: order.id,
						additionalServices: cart.additionalServices || []
					}
				)
			);
		});

		this.renderCount(order.carts.length);
	}

	renderCount(count) {
		$(".js-count-event").text(count);
	}

	/**
	 * Обновляет текст кнопки покупки в зависимости от суммы
	 * @param amount {number|string} - Сумма заказа
	 */
	updateBuyButtonText(amount) {
		const numericAmount = parseFloat(amount);
		
		const desktopSpan = this.$placesBuy.find('.d-none.d-sm-inline');
		const mobileSpan = this.$placesBuy.find('.d-inline-flex.d-sm-none');
		
		if (!isNaN(numericAmount) && numericAmount === 0) {
			if (desktopSpan.length) {
				desktopSpan.text(translator.t("main", "Continue"));
			}
			if (mobileSpan.length) {
				mobileSpan.text(translator.t("main", "Next"));
			}
		} else {
			if (desktopSpan.length) {
				desktopSpan.text(translator.t("main", "Buy"));
			}
			if (mobileSpan.length) {
				mobileSpan.text(translator.t("main", "Next"));
			}
		}
	}
}